import { lazy } from 'react';

import { Location } from '@cobliteam/common-types';

const SettingsPage = lazy(() => import('@cobliteam/account'));

const routes = [
  {
    path: Location.CONFIG,
    component: SettingsPage,
  },
];

export default routes;
